import { HIDE_LOADING, SHOW_LOADING } from "./actionType";

export const setShowLoadingToState = () => ({
    type: SHOW_LOADING
})
export const setHideLoadingToState = () => ({
    type: HIDE_LOADING,
})
export const showLoading = ()=>{
    return dispatch =>{
        dispatch(setShowLoadingToState())
    }
}
export const hideLoading = ()=>{
    return dispatch =>{
        dispatch(setHideLoadingToState())
    }
}
